import { OrderStaggingType } from "@/enums";

export const AppEnvironments = {
    Development: 'development',
    Production: 'production',
    CTDStaging: 'ctd-staging',
};
export const AdminCredentails = `admin password1`;
export const DEFAULT_TIME_ZONE = "UTC";
export const INITIAL_EVENTS = [
    {
        id: 1,
        title: "All-day event",
        start: new Date(),
    },
];
export const EVENT_TYPES = [
    {
        key: "delivery",
        value: "delivery",
    },
    {
        key: "pickup",
        value: "pickup",
    }
];
export const ORDER_LINE_REMARKS_FOR_EVENT_TYPE = "08";
export const TIME_SLOTS = [
    "12:00 AM", "12:30 AM",
    "01:00 AM", "01:30 AM",
    "02:00 AM", "02:30 AM",
    "03:00 AM", "03:30 AM",
    "04:00 AM", "04:30 AM",
    "05:00 AM", "05:30 AM",
    "06:00 AM", "06:30 AM",
    "07:00 AM", "07:30 AM",
    "08:00 AM", "08:30 AM",
    "09:00 AM", "09:30 AM",
    "10:00 AM", "10:30 AM",
    "11:00 AM", "11:30 AM",
    "12:00 PM", "12:30 PM",
    "01:00 PM", "01:30 PM",
    "02:00 PM", "02:30 PM",
    "03:00 PM", "03:30 PM",
    "04:00 PM", "04:30 PM",
    "05:00 PM", "05:30 PM",
    "06:00 PM", "06:30 PM",
    "07:00 PM", "07:30 PM",
    "08:00 PM", "08:30 PM",
    "09:00 PM", "09:30 PM",
    "10:00 PM", "10:30 PM",
    "11:00 PM", "11:30 PM"
    // "00:00 AM", "00:15 AM", "00:30 AM", "00:45 AM",
    // "01:00 AM", "01:15 AM", "01:30 AM", "01:45 AM",
    // "02:00 AM", "02:15 AM", "02:30 AM", "02:45 AM",
    // "03:00 AM", "03:15 AM", "03:30 AM", "03:45 AM",
    // "04:00 AM", "04:15 AM", "04:30 AM", "04:45 AM",
    // "05:00 AM", "05:15 AM", "05:30 AM", "05:45 AM",
    // "06:00 AM", "06:15 AM", "06:30 AM", "06:45 AM",
    // "07:00 AM", "07:15 AM", "07:30 AM", "07:45 AM",
    // "08:00 AM", "08:15 AM", "08:30 AM", "08:45 AM",
    // "09:00 AM", "09:15 AM", "09:30 AM", "09:45 AM",
    // "10:00 AM", "10:15 AM", "10:30 AM", "10:45 AM",
    // "11:00 AM", "11:15 AM", "11:30 AM", "11:45 AM",
    // "12:00 PM", "12:15 PM", "12:30 PM", "12:45 PM",
    // "01:00 PM", "01:15 PM", "01:30 PM", "01:45 PM",
    // "02:00 PM", "02:15 PM", "02:30 PM", "02:45 PM",
    // "03:00 PM", "03:15 PM", "03:30 PM", "03:45 PM",
    // "04:00 PM", "04:15 PM", "04:30 PM", "04:45 PM",
    // "05:00 PM", "05:15 PM", "05:30 PM", "05:45 PM",
    // "06:00 PM", "06:15 PM", "06:30 PM", "06:45 PM",
    // "07:00 PM", "07:15 PM", "07:30 PM", "07:45 PM",
    // "08:00 PM", "08:15 PM", "08:30 PM", "08:45 PM",
    // "09:00 PM", "09:15 PM", "09:30 PM", "09:45 PM",
    // "10:00 PM", "10:15 PM", "10:30 PM", "10:45 PM",
    // "11:00 PM", "11:15 PM", "11:30 PM", "11:45 PM"
];

export const ALERT_MESSAGES = {
    EVENT_CREATED: "Event has created",
    EVENT_UPDATED: "Event has updated",
    EVENT_REMOVED: "Event has removed",
};
export const DEFAULT_EVENT_TYPE = OrderStaggingType.Delivery.toString();
export const DEFAULT_EVENT_DURATION = "00:30";
export const DEFAULT_DATE_FORMAT = "DD-MMM-YYYY";
export const DEFAULT_SHIP_TIME = "00:00";
export const EVENT_COLORS = {
    GREEN: "#43a047",
    BLUE: "#448aff"
};
export const CALENDAR_VIEWS = {
    dayGridMonth: "dayGridMonth",
    timeGridWeek: "timeGridWeek",
    timeGridDay: "timeGridDay"
}


export const REMARKS_OPTIONS = [
    { id: 1, title: 'Remarks 1' },
    { id: 2, title: 'Remarks 2' },
    { id: 3, title: 'Remarks 3' },
    { id: 4, title: 'Remarks 4' },
    { id: 5, title: 'Remarks 5' },
    { id: 6, title: 'Remarks 6' },
    { id: 7, title: 'Remarks 7' },
    { id: 8, title: 'Remarks 8' },
    { id: 9, title: 'Remarks 9' },
    { id: 10, title: 'Remarks 10' },
    { id: 11, title: 'Remarks 11' },
    { id: 12, title: 'Remarks 12' },
    { id: 13, title: 'Remarks 10' },
    { id: 14, title: 'Remarks 14' },
    { id: 15, title: 'Remarks 15' },
    { id: 16, title: 'Remarks 16' },
    { id: 17, title: 'Remarks 17' },
    { id: 18, title: 'Remarks 18' },

];

export const EmailVariables = {
    OrderNumber: "@SalesOrderNumber",
    LocationDescription: "@LocationDescription",
    DeliveryPointName: "@DeliveryPointName",
    DeliveryDateTime: "@DeliveryDateTime",
    Deliveredby: "@Deliveredby",
    LocationPhone: "@LocationPhone",
    Signature: "@Signature",
   // DeliveryPicture: "@DeliveryPicture",
    LocationLink: "@LocationLink",
    PDFLink: "@PDFLink",
    CarriageReturn: "@CarriageReturn"
};

export const WareHouseProConfigConstants = {
    Enable: true,
    ModuleName: "Warehouse_Pro",
    RemarkConfigurationForShipmentType: 'RemarkConfigurationForShipmentType',
    RemarkConfigurationForShipmentTime: 'RemarkConfigurationForShipmentTime',

    SubjectForDeliveryWhenStagged: `Your Order# ${EmailVariables.OrderNumber} has been prepared to ship at ${EmailVariables.LocationDescription}`,
    MessageForDeliveryWhenStagged: `Your Order# ${EmailVariables.OrderNumber} has been prepared to ship at ${EmailVariables.LocationDescription}. ${EmailVariables.CarriageReturn} We will update you when your order is loaded and on the way.`,
    SMSForDeliveryWhenStagged: `Your Order# ${EmailVariables.OrderNumber} has been prepared to ship at ${EmailVariables.LocationDescription}. ${EmailVariables.CarriageReturn} We will update you when your order is loaded and on the way.`,

    SubjectForPickupWhenStagged: `Your Order# ${EmailVariables.OrderNumber} is ready to be picked up at ${EmailVariables.LocationDescription}`,
    MessageForPickupWhenStagged: `Your Order# ${EmailVariables.OrderNumber} is ready to be picked up at ${EmailVariables.LocationDescription}`,
    SMSForPickupWhenStagged: `Your Order# ${EmailVariables.OrderNumber} is ready to be picked up at ${EmailVariables.LocationDescription}`,

    SubjectForDeliveryWhenLoaded: `Your Order# ${EmailVariables.OrderNumber} is being loaded for delivery`,
    MessageForDeliveryWhenLoaded: `Your Order# ${EmailVariables.OrderNumber} is being loaded for delivery. ${EmailVariables.CarriageReturn} Get ready! Your delivery is now being loaded for delivery. Your order should be delivered within the next 12-24 hrs. ${EmailVariables.CarriageReturn} and we will notify you once delivered. ${EmailVariables.CarriageReturn} Here is the summary of the products scheduled for delivery.`,
    SMSForDeliveryWhenLoaded: `Your Order# ${EmailVariables.OrderNumber} is being loaded for delivery. ${EmailVariables.CarriageReturn} Get ready! Your delivery is now being loaded for delivery. Your order should be delivered within the next 12-24 hrs. ${EmailVariables.CarriageReturn} and we will notify you once delivered. ${EmailVariables.CarriageReturn} Here is the summary of the products scheduled for delivery.`,

    SubjectForDeliveryWhenShipped: `Your order# ${EmailVariables.OrderNumber} is out for delivery.`,
    MessageForDeliveryWhenShipped: `Your order# ${EmailVariables.OrderNumber} is out for delivery. ${EmailVariables.CarriageReturn} Here is the summary of the products scheduled for delivery. ${EmailVariables.CarriageReturn}`,
    SMSForDeliveryWhenShipped: `Your order# ${EmailVariables.OrderNumber} is out for delivery. ${EmailVariables.CarriageReturn} Here is the summary of the products scheduled for delivery. ${EmailVariables.CarriageReturn}`,

    SubjectForDeliveryWhenDelivered: `Your order# ${EmailVariables.OrderNumber} has been delivered.`,
   //MessageForDeliveryWhenDelivered: `Your order# ${EmailVariables.OrderNumber} has been delivered. ${EmailVariables.CarriageReturn}Thank you for your order. Our team has just delivered at your location. Below are some key details about your delivery. ${EmailVariables.CarriageReturn}${EmailVariables.CarriageReturn}If there are any concerns about your delivery please contact us at ${EmailVariables.LocationPhone}. ${EmailVariables.CarriageReturn}${EmailVariables.CarriageReturn} Delivery date and time: ${EmailVariables.DeliveryDateTime}. ${EmailVariables.CarriageReturn}Delivery point name: ${EmailVariables.DeliveryPointName}. ${EmailVariables.CarriageReturn}Delivered by: ${EmailVariables.Deliveredby}. ${EmailVariables.CarriageReturn}Delivery Picture: ${EmailVariables.CarriageReturn}${EmailVariables.DeliveryPicture} ${EmailVariables.CarriageReturn}${EmailVariables.Signature} ${EmailVariables.CarriageReturn}`,
    MessageForDeliveryWhenDelivered: `Your order# ${EmailVariables.OrderNumber} has been delivered. ${EmailVariables.CarriageReturn}Thank you for your order. Our team has just delivered at your location. Below are some key details about your delivery. ${EmailVariables.CarriageReturn}${EmailVariables.CarriageReturn}If there are any concerns about your delivery please contact us at ${EmailVariables.LocationPhone}. ${EmailVariables.CarriageReturn}${EmailVariables.CarriageReturn} Delivery date and time: ${EmailVariables.DeliveryDateTime}. ${EmailVariables.CarriageReturn}Delivery point name: ${EmailVariables.DeliveryPointName}. ${EmailVariables.CarriageReturn}Delivered by: ${EmailVariables.Deliveredby}. ${EmailVariables.CarriageReturn} ${EmailVariables.CarriageReturn}${EmailVariables.Signature} ${EmailVariables.CarriageReturn}`,
    SMSForDeliveryWhenDelivered: `Your order# @SalesOrderNumber has been delivered. @CarriageReturnThank you for your order. Our team has just delivered at your location. Below are some key details about your delivery. @CarriageReturn@CarriageReturnIf there are any concerns about your delivery please contact us at @LocationPhone. @CarriageReturn@CarriageReturnDelivery date and time: @DeliveryDateTime. @CarriageReturnDelivered by: @Deliveredby @CarriageReturnDelivery point name: @DeliveryPointName  @CarriageReturn@CarriageReturnView delivery point location:@CarriageReturn@LocationLink   @CarriageReturn@CarriageReturnView order details: @PDFLink`,

    SubjectForStockAdditionWhenCompleted: `New Stock Addition Available for Review`,
    MessageForStockAdditionWhenCompleted: `New Stock Addition Completed in Warehouse PRO`,
    SMSForStockAdditionWhenCompleted: null,

    SubjectForDeliveryWhenUnLoaded: `Your Order# ${EmailVariables.OrderNumber} is being Unloaded from delivery`,
    MessageForDeliveryWhenUnLoaded:  `Your Order# ${EmailVariables.OrderNumber} is being Unloaded from delivery. ${EmailVariables.CarriageReturn} We will notify you once your order is loaded for delivered again. ${EmailVariables.CarriageReturn} Here is the summary of the products that were unloaded from delivery.`,
    SMSForDeliveryWhenUnLoaded: `Your Order# ${EmailVariables.OrderNumber} is being Unloaded from delivery. ${EmailVariables.CarriageReturn} We will notify you once your order is loaded for delivered again. ${EmailVariables.CarriageReturn} Here is the summary of the products that were unloaded from delivery.`,


};

export const CALENDAR_EVENTS = {
    CreateEvent: "CreateEvent",
    UpdateEvent: "UpdateEvent",
    SelectEvent: "SelectEvent",
    DeleteEvent: "DeleteEvent",
    ResizeEvent: "ResizeEvent",
    DateClickEvent: "DateClickEvent",
    UpdateCalndarViewEvent: "UpdateCalndarViewEvent"
}
export const StorageKeys = {
    AgentType: "AgentType",
    WareHouseProConfig: "WareHouseProConfig",
    RemarkConfigurationForShipmentType: "RemarkConfigurationForShipmentType",
    RemarkConfigurationForShipmentTime: "RemarkConfigurationForShipmentTime"
};

export const StoreFunctions = {
    GetSalesOrders: "getSalesOrders",
    SetSalesOrders: "setSalesOrders",
    SetSelectedPhysicalCount: "setSelectedPhysicalCount",
    SetSelectedPhysicalCountLocation: "setSelectedPhysicalCountLocation",
    SetSelectedPhysicalCountDeviceId: "setSelectedPhysicalCountDeviceId",
    GetSelectedPhysicalCountLocation: "getSelectedPhysicalCountLocation",
    GetSelectedPhysicalCountDeviceId: "getSelectedPhysicalCountDeviceId",
    GetSelectedPhysicalCount: "getSelectedPhysicalCount",
    SetUserInfo: "setUserInfo",
    setAgentInfo: "setAgentInfo",
    SetAgentNames: "setAgentNames",
    SetModules: "SetModules"
};


export const GoogleAnalyticsPropertyConfig = [
    {
        id: "UA-129331363-1",
        domains: ["localhost:8088", "actionlistctd.greenstonesystems.com", "actionlist.greenstonesystems.com"]
    },
    {
        id: "185124118",
        domains: ["localhost:8088", "actionlistctd.greenstonesystems.com", "actionlist.greenstonesystems.com"]
    },
    {
        id: "385911024",
        default: true,
        domains: ["localhost:8088", "actionlistctd.greenstonesystems.com", "actionlist.greenstonesystems.com"]
    }
];


export const DefaultLastFetchRunDateTime = "3";

export const Modules = {
    EsignGlobal:"Esign.Global",
    ESign:"ESign",
    WarehousePro:"WarehousePro",
    SalesPro:"SalesPro",
    BackgroundService: "BackgroundService",
    
}
// params: {
//     linker: {
//         domain: ["localhost:8088", "actionlistctd.greenstonesystems.com", "actionlist.greenstonesystems.com"]
//     }
// }